<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '90vw', height: '90vh' }"
  (onHide)="cancel()"
>
  <ng-template pTemplate="header">
    <h3>{{ 'competentAuthority.dialog.title' | transloco }}</h3>
  </ng-template>

  <ng-template pTemplate="content">
    <form class="p-fluid">
      <div class="field">
        <label for="name">{{ 'competentAuthority.dialog.name' | transloco }}</label>
        <input id="name" type="text" pInputText [(ngModel)]="authority.name" name="name" required/>
      </div>
    </form>
    <app-choose-contact
      [onlyCreateContact]="true"
      [newContact]="newContact"
      (newContactUpdated)="onSetNewContact($event)"
      (validationStatusChanged)="validationStatusChanged = $event"
      [allowEmptyValid]="true"
    />
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex gap-2">
      <p-button
        styleClass="p-button-text"
        (click)="cancel()"
        icon="pi pi-times"
        [text]="true"
        label="{{ 'modal.cancel' | transloco }}"
      />
      <p-button
        (click)="create(authority)"
        [disabled]="!authority.name.trim() && !validationStatusChanged"
        icon="pi pi-save"
        label="{{ 'modal.save' | transloco }}"
      />
    </div>
  </ng-template>
</p-dialog>
